// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Button } from '@mui/material';
import { AppIcon } from '@shared/ui-kit/components';
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';
import type { FC } from 'react';
import type { AccountsListHeaderProps } from './accounts-list';
import styles from './accounts-list.module.css';

export const AccountsListHeader: FC<AccountsListHeaderProps> = ({
  onAdd,
  onImportExcel,
}) => (
  <header className={styles['accounts-header']}>
    <div className={styles['accounts-header-toolbar']} role="toolbar">
      {onImportExcel ? (
        <Button
          type="button"
          variant="outlined"
          color="secondary"
          className={styles['accounts-import-button']}
          startIcon={<AppIcon icon="Upload" size="lg" color="inherit" />}
          onClick={onImportExcel}
          data-testid="bank-upload-accounts-import-excel"
        >
          <Translation
            i18nKey="aggregator.create-bank.accounts.import-from-excel"
            ns="aggregator"
          />
        </Button>
      ) : null}

      <Button
        type="button"
        color="secondary"
        className={styles['accounts-add-button']}
        startIcon={<AppIcon icon="Plus" size="lg" color="inherit" />}
        onClick={onAdd}
        data-testid="bank-upload-accounts-add"
      >
        <Translation
          i18nKey="aggregator.create-bank.accounts.add-account"
          ns="aggregator"
        />
      </Button>
    </div>
  </header>
);

AccountsListHeader.displayName = 'AccountsListHeader';
